import {
  Dialog,
  DialogTitle,
  Typography,
  Grid,
  makeStyles,
  DialogContent,
  Box,
  Avatar,
  CircularProgress,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import axios from 'axios';
import { appUrl } from '../../../../../utils/config';

// Helper function to dynamically assign colors to avatars
const stringToColor = (name) => {
  if (!name) return '#ccc'; // Default color

  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += ('00' + value.toString(16)).substr(-2);
  }
  return color;
};

const useStyles = makeStyles((theme) => ({
  titleGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem',
  },
  closeBtn: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '12px',
    right: '10px',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
      color: '#FF0000',
    },
  },
  timeline: {
    position: 'relative',
    paddingLeft: theme.spacing(3),
    height:'100%',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: theme.spacing(1.5),
      width: '3px',
      height: '100%',
      backgroundColor: '#ddd',
    },
  },
  commentContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(4),
    position: 'relative',
  },
  dateContainer: {
    marginBottom: theme.spacing(1),
    fontWeight: 'bold',
    minWidth: '100px',
    textAlign: 'left',
  },
  commentText: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(3),
    marginTop: '12px',
    flex: 1,
    lineHeight: '1.5',
  },
  dot: {
    position: 'absolute',
    top: '17px',
    left: '-16px',
    width: '11px',
    height: '11px',
    borderRadius: '50%',
    backgroundColor: '#000',
  },
  name: {
    marginTop: '10px',
    color: '#0066cc',
    textDecoration: 'underline',
    fontWeight: '400',
  },
  commentCard: {
    padding: theme.spacing(2),
    border: '1px solid #ddd',
    borderRadius: '8px',
    backgroundColor: '#f8f8f8',
    marginBottom: theme.spacing(2),
    width:'100%',
  },
}));

// Updated responseData with the new structure
const responseData = {
  collabrixWorkItemID: 123,
  reviewCommentsList: [
    {
      fileName: 'MethodQualification_v1.pdf',
      collabrixFileID: 7305,
      reviewComments: [
        {
          organizationID: 2,
          addedDate: '2024-09-20T09:19:40.205',
          collabrixReviewCommentID: 8295,
          addedByUserID: 20,
          reviewComments: 'hi',
          addedByUserName: 'Apeksha Petare',
        },
      ],
      fileType: 'scientific_file',
      versionNumber: 1,
    },
    {
      fileName: 'supportingData_v1.pdf',
      collabrixFileID: 7307,
      reviewComments: [
        {
          organizationID: 2,
          addedDate: '2024-09-20T09:39:56.735',
          collabrixReviewCommentID: 8296,
          addedByUserID: 1,
          reviewComments: 'hi',
          addedByUserName: 'Jeffrey Wilson',
        },
      ],
      fileType: 'supporting_file',
      versionNumber: 1,
    },
    {
      fileName: 'MethodQualification_v1 with Edits.pdf',
      collabrixFileID: 7308,
      reviewComments: [
        {
          organizationID: 2,
          addedDate: '2024-09-20T07:50:14.800',
          collabrixReviewCommentID: 7322,
          addedByUserID: 1,
          reviewComments: 'sample comment 2',
          addedByUserName: 'Jeffrey Wilson',
        },
        {
          organizationID: 2,
          addedDate: '2024-09-20T07:48:36.209',
          collabrixReviewCommentID: 7321,
          addedByUserID: 1,
          reviewComments: 'sample comments',
          addedByUserName: 'Jeffrey Wilson',
        },
      ],
      fileType: 'scientific_file',
      versionNumber: 1,
    },
  ],
};

const ViewCommentsDialog = (props) => {
  const { openDialog, closeViewCommentsDialog, workitemId } = props;
  const classes = useStyles();
  // const { reviewCommentsList } = responseData;
  const [reviewCommentsList, setReviewCommentList]=useState([])
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    let data = {
      collabrixWorkItemID: workitemId,
    }
      axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllReviewComments`,
      data
    )
    .then((res) => {
      if (res.data.status) {
        setIsLoading(false)
        setReviewCommentList(res.data.data.reviewCommentsList)
      } else {
        setIsLoading(false)
        setReviewCommentList([])
      }
    })
        .catch((err) => {
          setIsLoading(false)
          setReviewCommentList([])
          console.log(err)
        });
    
  },[workitemId])

  return (
    <Dialog open={openDialog} maxWidth="sm" fullWidth style={{ padding: '2rem' }}>
      <DialogTitle style={{ padding: '0px' }}>
        <Grid item xs={12} className={classes.header}>
          <Grid item xs={12} className={classes.titleGrid}>
            <Typography variant="h6" style={{ fontSize: '1.875rem' }}>
              View comments
            </Typography>
          </Grid>

          <Grid item xs={2} sm={2} md={2}>
            <Typography
              variant="body2"
              className={classes.closeBtn}
              onClick={closeViewCommentsDialog}
            >
              Cancel{' '}
              <CloseIcon style={{ fontSize: '35px', color: '#FF0000' }} />
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "100px", // Optional: Set a height to vertically center the loader
            }}
          >
            <CircularProgress />
          </div>
        ) : reviewCommentsList.length > 0 ? (
          reviewCommentsList.map((file, fileIndex) => (
              <Grid key={fileIndex} p={2}>
                <Typography variant="subtitle1" gutterBottom>
                  {file.fileName}
                </Typography>
                <Grid container>
                  <Box className={classes.commentCard}>
                    <Grid item xs={12}>
                      {file.reviewComments.map((comment, index) => (
                  
                        <Grid key={index} container>
                          <Grid item xs={2}>
                            <Typography
                              style={{ fontWeight: 'bold', color: 'black' }}
                              variant="body2"
                            >
                              {moment(comment.addedDate).format('DD-MMM-YYYY').toUpperCase()}
                            </Typography>
                            <Typography
                              style={{ fontWeight: 'bold', color: 'black' }}
                              variant="body2"
                            >
                              {moment(comment.addedDate).format('HH:mm:ss').toUpperCase()}
                            </Typography>
                          </Grid>
                          <Grid item xs={10}>
                            <Box className={classes.timeline}>
                              <Box className={classes.commentContainer}>
                                <span className={classes.dot}></span>

                                <Grid container justifyContent="space-between">
                                  <Grid item xs={8}>
                                    <Box className={classes.commentText}>
                                      <Typography variant="body2">
                                        {comment.reviewComments}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid
                                    xs={4}
                                    item
                                    style={{ display: 'flex', flexDirection: 'row' }}
                                  >
                                    <Typography
                                      style={{
                                        marginTop: '10px',
                                        fontWeight: '550',
                                      }}
                                    >
                                      by
                                    </Typography>
                                    <Avatar
                                      style={{
                                        backgroundColor: '#fff',
                                        color: stringToColor(comment.addedByUserName),
                                        border: `2px solid ${stringToColor(
                                          comment.addedByUserName
                                        )}`,
                                        width: '32px',
                                        height: '32px',
                                        marginRight: '8px',
                                        marginLeft: '8px',
                                        fontSize: '0.85rem',
                                        fontWeight: '700',
                                        boxShadow:
                                          '0px 4px 6px rgba(0, 0, 0, 0.4)', // Add shadow to the downside
                                      }}
                                    >
                                      {comment.addedByUserName
                                        .split(' ')
                                        .map((n) => n[0])
                                        .join('')}
                                    </Avatar>
                                    <Typography
                                      variant="body2"
                                      className={classes.name}
                                    >
                                      {comment.addedByUserName}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>
                  
                      ))}
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            ))
        ):
        (<div style={{textAlign:'center'}}>
          <Typography>No Records Found</Typography>
        </div>)}
      </DialogContent>
    </Dialog>
  );
};

export default ViewCommentsDialog;
